import z from "zod";
import AppFileService from "../../../../services/AppFileService";
import { AxiosError } from "axios";

const api = new AppFileService();
const FormSchema = z.object({
  id: z.string().optional(),
  fileName: z.string().min(1, "File name is required."),
  description: z.string().optional(),
});

export type State = {
  errors?: {
    fileName?: string[];
    description?: string[];
    file?: string[];
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    fileName?: string;
    description?: string;
  };
};

export async function addAppFile(
  prevState: State,
  formData: FormData
): Promise<State> {
  try {
    const validatedFields = FormSchema.safeParse({
      fileName: formData.get("fileName"),
      description: formData.get("description"),
    });

    if (!validatedFields.success) {
      console.log(validatedFields.error);
      return {
        errors: validatedFields.error.flatten().fieldErrors,
        message: "Missing Fields. Failed to Create App File.",
        success: false,
      };
    }
    const file = formData.get("file") as File;
    if (!file || file.size === 0) {
      return {
        errors: {
          file: ["File is required."],
        },
        message: "Missing Fields. Failed to Create App File.",
        success: false,
      };
    }

    const result = await api.addAppFile(formData);
    if (result.status == 201)
      return {
        message: "App File created successfully.",
        success: true,
      };
    else
      return {
        message: "Failed to create app file.",
        success: false,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create app file.",
      success: false,
    };
  }
}

export async function updateAppFile(
  id: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  try {
    const validatedFields = FormSchema.safeParse({
      fileName: formData.get("fileName"),
      description: formData.get("description"),
    });

    if (!validatedFields.success) {
      console.log(validatedFields.error);
      return {
        errors: validatedFields.error.flatten().fieldErrors,
        message: "Missing Fields. Failed to Update App File.",
        success: false,
      };
    }

    const { fileName, description } = validatedFields.data;
    await api.updateAppFile(id, { fileName, description });
    return {
      message: "App File updated successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update app file.",
      success: false,
    };
  }
}

export async function deleteAppFile(id: string, prevState: State) {
  try {
    const result  = await api.deleteAppFile(id);
    if(result.status == 200)
    return {
      message: "App File deleted successfully.",
      success: true,
    };
    else return {
      message: result.data.description,
      success: false,
    }
  } catch (e:AxiosError|any) {
    console.log(e);
    return {
      message: e.response?.data.description || "Failed to delete app file.",
      success: false,
    };
  }
}
